import { observer } from 'mobx-react';
import React from 'react';

import { UiIcon } from 'shared/uikit-new';
import { useMedia } from 'shared/hooks';

import { Store } from 'pages/calendar/store';

import './styles.scss';

export const CalendarPageDatePagination = observer(function CalendarPageDatePagination() {
    const { isDesktop } = useMedia();
    const label = () => {
        const monthTemplate = isDesktop ? 'MMMM' : 'MMM';
        if (Store.view === 'day') {
            return Store.date.format(`D ${monthTemplate} YYYY`);
        }
        if (Store.view === 'days') {
            const days = Store.getDaysForView();
            if (days.length > 0) {
                const start = days[0];
                const end = days[days.length - 1];

                if (!start.isSame(end, 'year')) {
                    return `${start.format(`D ${monthTemplate} YYYY`)} - ${end.format(`D ${monthTemplate} YYYY`)}`;
                }
                if (!start.isSame(end, 'month')) {
                    return `${start.format(`D ${monthTemplate}`)} - ${end.format(`D ${monthTemplate} YYYY`)}`;
                }
                return `${start.format('D')} - ${end.format(`D ${monthTemplate} YYYY`)}`;
            }
        }
        if (Store.view === 'week') {
            const start = Store.date.startOf('week');
            const end = Store.filter.noWeekends ? Store.date.endOf('week').subtract(2, 'day') : Store.date.endOf('week');

            if (!start.isSame(end, 'year')) {
                return `${start.format(`D ${monthTemplate} YYYY`)} - ${end.format(`D ${monthTemplate} YYYY`)}`;
            }
            if (!start.isSame(end, 'month')) {
                return `${start.format(`D ${monthTemplate}`)} - ${end.format(`D ${monthTemplate} YYYY`)}`;
            }
            return `${start.format('D')} - ${end.format(`D ${monthTemplate} YYYY`)}`;
        }
        if (Store.view === 'month') {
            return Store.date.format(`${monthTemplate} YYYY`);
        }
        return Store.date.format('YYYY');
    };

    return (
        <div className={'calendar-page-date-pagination'}>
            <div className="calendar-page-date-pagination__label">{label()}</div>
            <div className="calendar-page-date-pagination__actions">
                <UiIcon.ChevronLeft size={24} onClick={Store.prev} />
                <UiIcon.ChevronRight size={24} onClick={Store.next} />
            </div>
        </div>
    );
});
